import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import { mapStateToProps, mapDispatchToProps } from '../../utils';

import { updateAppState } from '../../actions/applicationState';

import LoginModal from '../../components/LoginModal';
import Loader from '../../components/Loader';

/*
 * Top-level component which provides global functionality upon state changes
 */
class ApplicationHelper extends Component {
  constructor(props) {
    super(props);

    this.loginModalCloseHandler = this.closeLoginModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);

      this.props.ga.pageview(window.location.pathname + window.location.search);
    }
  }

  closeLoginModal() {
    this.props.dispatch(updateAppState({
      login_modal_open: false,
    }));
  }

  render() {
    return (
      <div>
        {this.props.children}
        {
          this.props.appstate.loading ? (
            <Loader text={this.props.appstate.loading_text} />
          ) : false
        }
        <LoginModal
          history={this.props.history}
          dispatch={this.props.dispatch}
          open={this.props.appstate.login_modal_open}
          title={this.props.appstate.login_modal_title}
          closeHandler={this.loginModalCloseHandler} />
      </div>
    );
  }
}

ApplicationHelper.defaultProps = {
  children: [],
};

ApplicationHelper.propTypes = {
  appstate: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node).isRequired,
    PropTypes.object,
  ]),
  history: PropTypes.object.isRequired,
  ga: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]).isRequired,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ApplicationHelper));



// WEBPACK FOOTER //
// ./src/views/ApplicationHelper/index.js